import { Link, useLocation } from 'react-router-dom'

// Человекочитаемые названия сегментов URL
const LABELS = {
  admin: 'Обзор', users: 'Пользователи', cars: 'Машины', trips: 'Поездки',
  tickets: 'Тикеты', tasks: 'Задачи', reminders: 'Напоминания', chats: 'Чаты',
  video: 'Видеозвонки',
  regions: 'Регионы', structure: 'Структура', analytics: 'Аналитика', finance: 'Финансы',
  support: 'Помощь', profile: 'Профиль', verify: 'Верификация', new: 'Создание',
  infopanel: 'Информационная панель', logs: 'Журналы',
  kb: 'База знаний', groups: 'Группы',
  calendar: 'Календарь', settings: 'Настройки',
}

export function Breadcrumbs() {
  const { pathname } = useLocation()
  const parts = pathname.split('/').filter(Boolean)

  // На главных экранах крошки не нужны
  if (parts.length <= 1) return null

  let acc = ''
  const crumbs = parts.map((seg, i) => {
    acc += '/' + seg
    const isId = /^\d+$/.test(seg) || /^[0-9a-f-]{20,}$/i.test(seg)
    const label = isId ? `#${seg.slice(0, 8)}` : (LABELS[seg] || seg)
    return { to: acc, label, last: i === parts.length - 1 }
  })

  return (
    <nav className="breadcrumbs" aria-label="Хлебные крошки">
      {crumbs.map((c, i) => (
        <span key={c.to} className="breadcrumbs__item">
          {i > 0 && <span className="breadcrumbs__sep">/</span>}
          {c.last
            ? <span className="breadcrumbs__current">{c.label}</span>
            : <Link to={c.to}>{c.label}</Link>}
        </span>
      ))}
    </nav>
  )
}
